import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { logger } from './utils/logger';

logger.debug(
  `PERFORMANCE: JavaScript execution started at ${performance.now()}ms`
);
logger.debug(`PERFORMANCE: React imports loaded at ${performance.now()}ms`);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
